import Repository from "./Repository";

const resource = "/patients";
export default {
  get() {
    return Repository.get(`${resource}`);
  },

  getPatient(patientUuid) {
    return Repository.get(`${resource}/${patientUuid}`);
  },

  createPatient(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
